import React from 'react';
import {FlatList, Platform, View} from 'react-native';
import {observer} from 'mobx-react';

import {DEFAULT_CAROUSEL_NUM_ITEMS} from '../../constants/GlobalConstants';
import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';
import {AirtablePromotionItem} from '../../models/airtable';
import {usePromotions} from '../../queries/promotions';
import {brandRewardsCopy} from '../../utils/rewards';
import {visibleScrollbarProps} from '../../utils/webScrollbar';
import TitleLine from '../rewards/TitleLine';
import TileLarge from '../TileLarge';
type PromotionsCarouselProps = {
  onPromotionPress?: (item: AirtablePromotionItem) => void;
  onSeeAllPress?: () => void;
  numItems?: number;
};

const PromotionsCarousel = observer(
  ({
    onPromotionPress,
    onSeeAllPress,
    numItems = DEFAULT_CAROUSEL_NUM_ITEMS,
  }: PromotionsCarouselProps) => {
    const {carouselData} = usePromotions();

    const renderItem = createRenderItem(onPromotionPress);
    const items = carouselData?.slice(0, numItems) ?? [];

    const {isWebDesktopScreen} = useWebScreenDimensions();

    if (!items.length) {
      return null;
    }

    return (
      <View>
        <TitleLine
          title={brandRewardsCopy.promotionsTitle.toUpperCase()}
          onSeeAllPress={onSeeAllPress}
        />
        <FlatList
          horizontal
          data={items}
          renderItem={renderItem}
          ItemSeparatorComponent={Separator}
          showsHorizontalScrollIndicator={isWebDesktopScreen}
          {...visibleScrollbarProps(isWebDesktopScreen)}
          windowSize={3}
          maxToRenderPerBatch={3}
          initialNumToRender={3}
          removeClippedSubviews={Platform.OS === 'android'}
        />
      </View>
    );
  },
);

function Separator() {
  return <View style={{width: 8, height: 8}} />;
}

const createRenderItem =
  (onPromotionPress?: (item: AirtablePromotionItem) => void) =>
  ({item}: {item: AirtablePromotionItem}) => {
    return (
      <TileLarge
        title={item.headline}
        description={item.description}
        image={item.heroImage!}
        onPress={() => onPromotionPress?.(item)}
      />
    );
  };

export default PromotionsCarousel;
